import { FC } from 'react';

import { CloseIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { PaletteColor } from '@utils/types';

import { CloseButtonContainer, CloseButtonLabel } from './styled';

export const ModalCloseButton: FC<{
  onClick?: () => void;
  noLabel?: boolean;
  paletteColor?: PaletteColor;
}> = ({ noLabel = false, paletteColor = 'darkGray', ...rest }) => (
  <CloseButtonContainer {...rest}>
    {noLabel ? null : <CloseButtonLabel>Kapat</CloseButtonLabel>}
    <CustomIcon icon={CloseIcon} fontSize={24} paletteColor={paletteColor} />
  </CloseButtonContainer>
);
